import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {FormsService} from '../../../../shared/forms.service';
import {ActivatedRoute, Params} from '@angular/router';
import {HttpService} from '../../../../shared/http.service';
import {AlertService} from '../../../../shared/alert.service';

@Component({
  selector: 'app-subscriber-form',
  templateUrl: './subscriber-form.component.html',
  styleUrls: ['./subscriber-form.component.scss']
})
export class SubscriberFormComponent implements OnInit {
  subscriberForm: FormGroup;
  btnMsg: string;
  prev: string;
  h1: string;
  // editSubscriber = false;
  subscriberId: number;
  msg = {
    'add' : 'Suscriptor agregado con éxito',
    'error' : 'Hubo un error al agregar suscriptor'
  }

  constructor(private fb: FormBuilder,
              private route: ActivatedRoute,
              private formsService: FormsService,
              private alertService: AlertService,
              private httpService: HttpService) {
    this.createFormGroup();
  }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      if (params['subscriberId']) {
        this.subscriberId = params['subscriberId'];
        this.btnMsg = 'Editar Suscriptor';
        this.prev = '../../';
        this.httpService.getRaw('/Mailchimp/List/'+params['listId']+'/Members/'+params['subscriberId'], [])
          .subscribe(
            response => {
              this.subscriberForm.patchValue({
                'name': response['merge_fields']['FNAME'],
                'lastName': response['merge_fields']['LNAME'],
                'email': response['email_address'],
              });
            },
            error => {
              this.alertService.error(this.msg['error']);
            }
          )
      } else {
        this.btnMsg = 'Agregar Suscriptor';
        this.prev = '../';
      }
    });
  }

  submitForm() {
    this.route.params.subscribe((params: Params) => {
      if (params['listId']) {
        if (this.formsService.validateFormAndUpdateErrors(this.subscriberForm)) {
          let body = {};
          body["members"] = [];
          body["update_existing"] = true;
          body["members"].push(
            {
              "email_address": this.subscriberForm.get('email').value,
              "status": "subscribed",
              "merge_fields" : {
                "FNAME": (this.subscriberForm.get('name').value) ? this.subscriberForm.get('name').value : '',
                "LNAME": (this.subscriberForm.get('lastName').value) ? this.subscriberForm.get('lastName').value : '',
              }
            }
          );

          this.httpService.postRaw('/MailChimp/List/'+params['listId'], [], body)
            .subscribe(
              memberResponse => {
                this.alertService.success(this.msg['add']);
              },
              error => {
                this.alertService.error(this.msg['error']);
              }
            )
        }
      }
    });
  }

  public createFormGroup() {
    this.subscriberForm = this.fb.group({
      'name': [
        null,
        Validators.compose([
          Validators.maxLength(50)
        ])
      ],
      'lastName': [
        null,
        Validators.compose([
          Validators.maxLength(50)
        ])
      ],
      'email': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50)
        ])
      ]
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/mailchimp/subscriber/shared/subscriber-form/subscriber-form.component.ts